import _ from 'lodash';
import useParallelCase from './useParallelCase';
import HoverMessage from 'common/components/HoverMessage';
import { useResponsive } from 'v3/common/hooks/useResponsive';

export type CaseOption = {
  id: number;
  label: string;
};

type ParallelCaseProps = {
  parallelCasesOptions: CaseOption[];
  selectedItem: CaseOption[] | null;
  onSelectItem: (item: CaseOption[] | null) => void;
  isDisabled?: boolean;
};

const multipleCaseContent =
  'Define up to 10 different strategies within a single setup, each with its own logic. The system monitors all cases and executes the case that matches first, helping you test complementary and contrasting approaches effectively.';

const ParallelCase = ({
  parallelCasesOptions,
  selectedItem: initialSelectedItem,
  onSelectItem,
  isDisabled = false,
}: ParallelCaseProps) => {
  const isMobile = useResponsive();
  const {
    setIsOpen,
    isOpen,
    selectedItem,
    setSelectedItem,
    handleItemClick,
    handleCancel,
    handleApply,
    updatedCases,
    isAllSelected,
  } = useParallelCase({
    parallelCasesOptions,
    initialSelectedItem,
    onSelectItem,
    isDisabled,
  });

  const selectLabel = isAllSelected ? 'Deselect All' : 'Select All';

  const renderDropdown = () => {
    return (
      <div className={`drop-down-list ${isMobile ? 'mobile' : 'web'}`}>
        <ul className="drop-down-list-items">
          <li className="drop-down-item" onClick={() => setSelectedItem(isAllSelected ? [] : updatedCases)}>
            {selectLabel}
          </li>
          {updatedCases.map((item) => (
            <li
              key={item.id}
              className={`drop-down-item ${selectedItem.some((i) => i.id === item.id) ? 'active' : ''} `}
              onClick={() => !isDisabled && handleItemClick(item)}
            >
              {(selectedItem.some((i) => i.id === item.id) || isAllSelected) && (
                <i className="fa-solid fa-check"></i>
              )}{' '}
              {item.label}
            </li>
          ))}
        </ul>
        <div className="drop-down-divider"></div>
        <div className="d-flex justify-content-between mt-2">
          <div className="drop-down-action" onClick={handleCancel}>
            Cancel
          </div>
          <div className="drop-down-action btn-primary text-white" onClick={handleApply}>
            Apply
          </div>
        </div>
      </div>
    );
  };

  const renderSelectedItems = () =>
    _.map(initialSelectedItem, (item) => (
      <li className="" key={item.id}>
        {item?.label?.split(' ')[1]}
      </li>
    ));

  return (
    <div className="parallel-case-container">
      <span className="tx-15 font-weight-medium selector-text">Multiple Case</span>
      <HoverMessage message={multipleCaseContent}>
        <i className="fa-regular fa-circle-info info-icon"></i>
      </HoverMessage>
      <div className={`select-dropdown-container ${isMobile ? 'mobile' : 'web'}`}>
        <div
          className={`drop-down ${isDisabled ? 'disabled' : ''}`}
          onClick={() => {
            if (!isDisabled) setIsOpen(!isOpen);
          }}
        >
          <span className="multiple-case-label">Select Parallel Cases</span>
          <ul className="selected-cases-label " style={{ listStyleType: 'none' }}>
            {renderSelectedItems()}
          </ul>
          <i className="fa-solid fa-caret-down" />
        </div>
        {isOpen && renderDropdown()}
      </div>
    </div>
  );
};

export default ParallelCase;
